import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';

import LanguageDropdown from '../../Language/LanguageDropdown';
import { COLOR_SECONDARY, COLOR_TEXT_MUTED } from '../../../constants/styleValues';

const componentContent = {
    language_DE: {
        copyPin: 'PIN kopieren',
        copied: 'Kopiert!',
        leave: 'Spiel verlassen'
    },
    language_EN: {
        copyPin: 'Copy PIN',
        copied: 'Copied!',
        leave: 'Leave game'
    },
    language_FR: {
        copyPin: 'Copier le PIN',
        copied: 'Copié !',
        leave: 'Quitter la partie'
    }
}

//persistent bar shown above every Play screen once a room exists: room PIN (copyable), player name, leave button
const TopBar = () => {
    const navigate = useNavigate();
    const playQuiz = useSelector((state) => state.PlayQuiz);
    const playerName = useSelector((state) => state.Cookie.playerName);
    const selectedLanguage = useSelector((state) => state.Language);
    const [copied, setCopied] = useState(false);

    const handleCopyPin = () => {
        navigator.clipboard.writeText(String(playQuiz.quizId));
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const handleLeave = () => {
        navigate('/');
    };

    if(!playQuiz || !playQuiz.quizId){
        return null;
    }

    return (
        <Box sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            width: '100%',
            borderBottom: '1px solid rgba(255,255,255,0.10)',
            backgroundColor: 'rgba(27,16,48,0.85)',
            backdropFilter: 'blur(6px)'
        }}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                maxWidth: '600px',
                margin: '0 auto',
                padding: '10px 16px'
            }}>
                <Tooltip title={copied ? componentContent[selectedLanguage].copied : componentContent[selectedLanguage].copyPin}>
                    <Box
                        component="button"
                        onClick={handleCopyPin}
                        aria-label={componentContent[selectedLanguage].copyPin}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            cursor: 'pointer',
                            backgroundColor: 'rgba(255,200,87,0.12)',
                            border: '1px solid rgba(255,200,87,0.4)',
                            borderRadius: '999px',
                            padding: '6px 10px 6px 12px',
                            font: 'inherit'
                        }}
                    >
                        <Typography sx={{ fontSize: '13px', fontWeight: 700, letterSpacing: '0.04em', color: COLOR_SECONDARY }}>
                            PIN {playQuiz.quizId}
                        </Typography>
                        <ContentCopyIcon sx={{ fontSize: '14px', color: COLOR_SECONDARY }} />
                    </Box>
                </Tooltip>

                <LanguageDropdown />

                {playerName ?
                    <Typography variant="body2" noWrap sx={{ flex: 1, textAlign: 'right', color: COLOR_TEXT_MUTED }}>
                        {playerName}
                    </Typography>
                    : <Box sx={{ flex: 1 }} />
                }

                <IconButton aria-label={componentContent[selectedLanguage].leave} onClick={handleLeave} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default TopBar;
